import { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Badge,
} from "reactstrap";
import "./order.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import EcommerceOrderProduct from "./OrderProduct";
import { listDeliveryInstructions, OrderStatus, updateOrdersRouteStoreDriver, UpdateOrderStatus, viewOrder } from "./_requests";
import { updateUser } from "../User/_requests";
import OrderTracking from "./OrderTracking";
import { useToast } from "../../Components/Common/ToastContext";
import { toast, ToastContainer } from "react-toastify";
import OrderStatusModal from "./OrderStatusModal";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import OrderRouteUpdate from "./OrderRouteUpdate";
import OrderStoreUpdate from "./OrderStoreUpdate";
import { listDriver, listRoute, refundOrderAPI } from "../../pages/Route/_requests";
import { listStore } from "../../pages/Route/_requests";
import OrderDeliveryDateUpdate from "./OrderDeliveryDateUpdate";
import DeliveryDriverAllocateOrder from "./DeliveryDriverAllocateOrder.";
import { formatDate } from "../../helpers/FunctionHelpers";

const OrderDetail = () => {
  const { id } = useParams();
  const { showToast, toaster, clearToast } = useToast();
  const [order, setOrder] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedDriver, setSelectedDriver] = useState("");
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState<Date | null>(null);
  const [isRouteModalOpen, setIsRouteModalOpen] = useState(false);
  const [isStoreModalOpen, setIsStoreModalOpen] = useState(false);
  const [isDriverModalOpen, setIsDriverModalOpen] = useState(false);
  const [isDeliveryDateModalOpen, setIsDeliveryDateModalOpen] = useState(false);
  const [orderStatusLists, setStatus] = useState<{ id: string; name: string }[]>([]);
  const [ordersListRoute, setRoute] = useState<any>([]);
  const [ordersListStore, setStore] = useState<any>([]);
  const [ordersListDriver, setDriver] = useState<any>([]);
  const [deliveryInstructions, setDeliveryInstructions] = useState<any[]>([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [refundReason, setRefundReason] = useState("");
  const [isRefunding, setIsRefunding] = useState(false);

  const [editNameModal, setEditNameModal] = useState<boolean>(false);
  const [editNameValue, setEditNameValue] = useState<string>("");
  const [updatingName, setUpdatingName] = useState<boolean>(false);

  const toggleEditNameModal = () => {
    if (!editNameModal && order?.user) {
      setEditNameValue(order.user.name || "");
    }
    setEditNameModal(!editNameModal);
  };

  const handleSaveUserName = async () => {
    if (!editNameValue.trim()) {
      toast.error("Name cannot be empty");
      return;
    }
    if (!order?.user?.id) {
      toast.error("User ID not found");
      return;
    }
    try {
      setUpdatingName(true);
      const res = await updateUser(order.user.id, { name: editNameValue.trim() });
      if (res?.status) {
        toast.success("User name updated successfully");
        setOrder((prev: any) => ({
          ...prev,
          user: { ...prev?.user, name: editNameValue.trim() }
        }));
        setEditNameModal(false);
      } else {
        toast.error(res?.message || "Failed to update user name");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Failed to update user name");
    } finally {
      setUpdatingName(false);
    }
  };

  const [mapModal, setMapModal] = useState<boolean>(false);
  const [mapLocationData, setMapLocationData] = useState<{
    title?: string;
    address?: string;
    lat?: number | string;
    lng?: number | string;
  } | null>(null);

  const toggleMapModal = () => {
    setMapModal(!mapModal);
  };

  const isNewCustomer = (user: any) => {
    if (!user) return false;
    if (user.is_new_customer) return true;
    if (user.is_trial_used === 0 || user.is_trial_used === false) return true;
    if (user.created_at) {
      const diffDays = (new Date().getTime() - new Date(user.created_at).getTime()) / (1000 * 3600 * 24);
      if (diffDays <= 30) return true;
    }
    return false;
  };

  const handleOpenMapModal = (data: { title?: string; address?: string; lat?: any; lng?: any }) => {
    setMapLocationData(data);
    setMapModal(true);
  };


  // Add this function to handle refund submission
  const [refundAmount, setRefundAmount] = useState<number | string>("");
  const [showRefundModal, setShowRefundModal] = useState(false);
  console.log("order state ", order)
  // Update your handleRefund function
  const handleRefund = async () => {
    if (!refundReason) {
      showToast("Please enter a refund reason", false);
      return;
    }

    // Use the refundAmount if provided, otherwise default to order total
    const amountToRefund = refundAmount !== "" ? Number(refundAmount) : order?.total_amount;

    if (isNaN(amountToRefund)) {
      showToast("Please enter a valid refund amount", false);
      return;
    }

    setIsRefunding(true);
    try {
      const data = {
        order_id: parseInt(id || "0"),
        tracking_status: 12, // Status for Refunded
        user_id: order?.user?.id,
        payment_id: order?.payment_id,
        amount: amountToRefund,
        reason: refundReason,
      };

      const res: any = await refundOrderAPI(data);
      if (res.status === true) {
        showToast(res.message, res.status);
        fetchOrder(); // Refresh order data
        setRefundReason(""); // Reset reason
        setRefundAmount(""); // Reset amount
        setShowRefundModal(false); // Close modal
      } else {
        showToast(res.message, res.status);
      }
    } catch (error) {
      showToast("Failed to process refund", false);
      console.error("Refund error:", error);
    } finally {
      setIsRefunding(false);
    }
  };
  console.log("orderStatusLists", orderStatusLists)
  useEffect(() => {
    if (toaster?.message) {
      toast[toaster.status ? "success" : "error"](toaster.message, { autoClose: 3000 });
      clearToast();
    }
  }, [toaster, clearToast]);

  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);

  useEffect(() => {
    fetchOrder();
    OrderStatus().then((res: any) => {
      setStatus(res.data || []);
    });

    listDeliveryInstructions().then((res: any) => {
      setDeliveryInstructions(res.data || []);
    });

    listStore().then((res: any) => {
      setStore(res.data);
    });

    listRoute().then((res: any) => {
      setRoute(res.data);
    });

    listDriver().then((res: any) => {
      setDriver(res.data);
    });
  }, [id]);

  const fetchOrder = useCallback(async () => {
    try {
      const res = await viewOrder(id);
      if (res.data) {
        setOrder(res.data);
        // Update all related states
        if (res.data?.orderStatus?.id) {
          setSelectedStatus(res.data.orderStatus.id.toString());
        }
        if (res.data?.route?.id) {
          setSelectedRoute(res.data.route.id.toString());
        }
        if (res.data?.driver?.id) {
          setSelectedDriver(res.data.driver.id.toString());
        }
        if (res.data?.store?.id) {
          setSelectedStore(res.data.store.id.toString());
        }
        if (res.data?.delivery_date) {
          setSelectedDeliveryDate(new Date(res.data.delivery_date));
        }
      }
    } catch (error) {
      console.error("Failed to fetch order:", error);
    }
  }, [id]);

  const handleRouteUpdate = async () => {
    const data = { order_id: selectedOrderId, route_id: selectedRoute };
    const res: any = await updateOrdersRouteStoreDriver(data);
    if (res.status === true) {
      showToast(res.message, res.status);
      fetchOrder();
    } else {
      showToast(res.message, res.status);
    }
    toggleRouteModal();
  };

  const handleStoreUpdate = async () => {
    const data = { order_id: selectedOrderId, store_id: selectedStore };
    const res: any = await updateOrdersRouteStoreDriver(data);
    if (res.status === true) {
      showToast(res.message, res.status);
      fetchOrder();
    } else {
      showToast(res.message, res.status);
    }
    toggleStoreModal();
  };
  const handleDriverUpdate = async () => {
    const data = { order_id: selectedOrderId, driver_id: selectedDriver };
    const res: any = await updateOrdersRouteStoreDriver(data);
    if (res.status === true) {
      showToast(res.message, res.status);
      fetchOrder();
    } else {
      showToast(res.message, res.status);
    }
    toggleDriverModal();
  };




  const handleStatus = async () => {
    const data = { order_id: parseInt(id || "0"), tracking_status: parseInt(selectedStatus || "0") };

    console.log("data", data);
    const res: any = await UpdateOrderStatus(data);
    if (res.status === true) {
      showToast(res.message, res.status);
      fetchOrder();
    } else {
      showToast(res.message, res.status);
    }
  };
  const handleDeliveryDateUpdate = async () => {
    const data = { order_id: id, delivery_date: selectedDeliveryDate };
    const res: any = await updateOrdersRouteStoreDriver(data);
    if (res.status === true) {
      showToast(res.message, res.status);
      fetchOrder();
    } else {
      showToast(res.message, res.status);
    }
    toggleDeliveryDateModal();
  };

  const toggleRouteModal = (orderId?: number) => {
    if (orderId !== undefined) {
      setSelectedOrderId(orderId);
    }
    setIsRouteModalOpen((prev) => !prev);
  };

  const toggleStoreModal = (orderId?: number) => {
    if (orderId !== undefined) {
      setSelectedOrderId(orderId);
    }
    setIsStoreModalOpen((prev) => !prev);
  };

  const toggleModal = useCallback((orderId?: number) => {

    if (orderId !== undefined) {
      setSelectedOrderId(orderId);
    }
    setIsModalOpen(prev => !prev);
  }, []);


  const toggleDriverModal = (orderId?: number) => {
    if (orderId !== undefined) {
      setSelectedOrderId(orderId);
    }
    setIsDriverModalOpen((prev) => !prev);
  };

  const toggleDeliveryDateModal = (orderId?: number) => {
    if (orderId !== undefined) {
      setSelectedOrderId(orderId);
    }
    setIsDeliveryDateModalOpen((prev) => !prev);
  };

  document.title = "Paal Dappa | Order Details";

  const downloadInvoice = () => {
    if (order?.receipt) {
      window.open(order.receipt, '_blank');
    } else {
      toast.error("No invoice available for this order");
    }
  };

  const formatAmount = (amount: number | undefined): string =>
    amount !== undefined ? new Intl.NumberFormat("en-IN").format(amount) : "—";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="🎯 Order Details" pageTitle="Paal Dappa" />
        <ToastContainer closeButton={false} limit={1} />
        <div id="invoice-section">
          <Row>
            <Col xl={6}>
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-warning-subtle text-dark d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">🚚 Route Update</h5>
                  <Button color="dark" size="sm" onClick={() => toggleRouteModal(id ? Number(id) : undefined)}>
                    <i className="ri-edit-2-line me-1"></i> Update
                  </Button>
                </CardHeader>
                <CardBody>
                  {order?.route?.name || "-"}
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-warning-subtle text-dark d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">📦 Store Update</h5>
                  <Button color="dark" size="sm" onClick={() => toggleStoreModal(id ? Number(id) : undefined)}>
                    <i className="ri-edit-2-line me-1"></i> Update
                  </Button>
                </CardHeader>
                <CardBody>
                  {order?.store?.name || "-"}
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-warning-subtle text-dark d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">📅 Delivery Date</h5>
                  <Button color="dark" size="sm" onClick={() => toggleDeliveryDateModal(id ? Number(id) : undefined)}>
                    <i className="ri-edit-2-line me-1"></i> Update
                  </Button>
                </CardHeader>
                <CardBody>
                  {order?.delivery_date
                    ? formatDate(order.delivery_date)
                    : "—"}
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-warning-subtle text-dark d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">👨‍✈️ Delivery Driver</h5>
                  <Button color="dark" size="sm" onClick={() => toggleDriverModal(id ? Number(id) : undefined)}>
                    <i className="ri-edit-2-line me-1"></i> Update
                  </Button>
                </CardHeader>
                <CardBody>
                  {order?.driver?.name || "-"}
                </CardBody>
              </Card>
            </Col>

            {/* Order Info */}
            <Col xl={8}>
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-gradient-primary text-white d-flex align-items-center">
                  <h5 className="flex-grow-1 mb-0 fw-bold text-primary">
                    {order?.order_code_id}
                    {(order?.is_first_order || isNewCustomer(order?.user)) && (
                      <Badge color="danger" className="ms-2">NEW</Badge>
                    )}
                  </h5>
                  <Button className="btn btn-light btn-sm" onClick={downloadInvoice}>
                    <i className="ri-download-2-fill me-1"></i> Invoice
                  </Button>
                  <Link to={`/orders/invoice-download/${id}`} className="btn btn-warning btn-sm ms-2">
                    <i className="ri-printer-line me-1"></i> New Invoice
                  </Link>
                </CardHeader>

                <CardBody className="bg-light">
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle">
                      <thead className="table-info text-dark">
                        <tr>
                          <th>Product Details</th>
                          <th>Item Price</th>
                          <th>Quantity</th>
                          <th className="text-end">Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {order?.orderItems?.map((item: any, index: number) => (
                          <EcommerceOrderProduct key={item?.id || index} orderItem={item} />
                        ))}
                        <tr className="bg-white border-top">
                          <td colSpan={4}>
                            <table className="table table-sm mb-0">
                              <tbody>
                                <tr>
                                  <td className="fw-bold w-50">Subtotal</td>
                                  <td className="text-end">{formatAmount(order?.sub_total_amount)}</td>
                                </tr>
                                <tr>
                                  <td>Discount</td>
                                  <th className="text-end text-danger">
                                    {formatAmount((order?.total_amount || 0) - (order?.sub_total_amount || 0))}
                                  </th>
                                </tr>
                                <tr>
                                  <td>Shipping Charge</td>
                                  <td className="text-end">{formatAmount(order?.shipping_charge)}</td>
                                </tr>
                                <tr>
                                  <td>Tax</td>
                                  <td className="text-end">{formatAmount(order?.tax_amount)}</td>
                                </tr>
                                <tr>
                                  <td>Coupon Code</td>
                                  <td className="text-end text-primary">{order?.coupon_code || "—"}</td>
                                </tr>
                                <tr className="table-success">
                                  <th>Total</th>
                                  <th className="text-end">{formatAmount(order?.total_amount)}</th>
                                </tr>
                                {order?.OrderRefund && (Array.isArray(order.OrderRefund) ? order.OrderRefund.length > 0 : true) && (
                                  <tr className="table-danger">
                                    <th colSpan={2} className="py-3">
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span className="text-danger">💸 Refund Information {order?.is_trial_plan || order?.order_type_name === 'Trial Order' ? "(Trial Order)" : ""}</span>
                                        <Badge color="danger">
                                          {Array.isArray(order.OrderRefund) ? order.OrderRefund[0]?.status : order.OrderRefund?.status}
                                        </Badge>
                                      </div>
                                      <div className="small fw-normal">
                                        <span className="fw-bold text-dark">Refund ID:</span> {Array.isArray(order.OrderRefund) ? order.OrderRefund[0]?.refund_id : order.OrderRefund?.refund_id}
                                        <br />
                                        <span className="fw-bold text-dark">Refund Amount:</span> {formatAmount(Array.isArray(order.OrderRefund) ? order.OrderRefund[0]?.amount : order.OrderRefund?.amount)}
                                        <br />
                                        <span className="fw-bold text-dark">Date:</span> {formatDate(Array.isArray(order.OrderRefund) ? order.OrderRefund[0]?.created_at : order.OrderRefund?.created_at)}
                                        <br />
                                        <span className="fw-bold text-dark">Reason:</span> {Array.isArray(order.OrderRefund) ? order.OrderRefund[0]?.description : order.OrderRefund?.description}
                                      </div>
                                    </th>
                                  </tr>
                                )}
                                <tr>
                                  <td>Payment Method</td>
                                  <td className="text-end">{order?.paymentMethod?.name}</td>
                                </tr>
                                <tr>
                                  <td>Order Status</td>
                                  <td className={`text-end fw-semibold ${order?.orderStatus?.id === 3 || order?.orderStatus?.id === 4 || order?.orderStatus?.id === 10 ? "text-danger" :
                                      order?.orderStatus?.id === 12 ? "text-info" :
                                        "text-success"
                                    }`}>
                                    {order?.orderStatus?.name}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Right Panel */}
            <Col xl={4}>
              {/* Delivery Instructions */}
              {(order?.delivery_instructions_id || "").split(",").filter((id: string) => id.trim()).length > 0 && (
                <Card className="shadow-sm border-0 mb-3">
                  <CardHeader className="bg-info-subtle text-dark d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">📝 Delivery Instructions</h5>
                  </CardHeader>
                  <CardBody>
                    <div className="d-flex flex-wrap gap-2">
                      {(order?.delivery_instructions_id || "")
                        .split(",")
                        .map((id: string) => parseInt(id.trim()))
                        .filter(Boolean)
                        .map((id: number) => {
                          const inst = deliveryInstructions.find((item: any) => item.id === id);
                          if (!inst) return null;
                          return (
                            <span
                              key={id}
                              className="badge p-2 fs-6"
                              style={{ backgroundColor: inst.color || '#6c757d' }}
                              title={inst.description}
                            >
                              {inst.name}
                            </span>
                          );
                        })}
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* Order Status Tracker */}
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-warning-subtle text-dark d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0">🚚 Order Status</h5>
                    {order?.order_status_id === 8 && (
                      <span className="ms-2 badge bg-success bg-opacity-10 text-success">
                        <i className="ri-checkbox-circle-fill me-1"></i> Delivered
                      </span>
                    )}
                  </div>

                  <div className="position-relative">
                    <Button
                      color="dark"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleModal(order?.id);
                      }}
                      disabled={order?.order_status_id === 8}
                      id="statusUpdateButton"
                    >
                      <i className="ri-edit-2-line me-1"></i> Update
                    </Button>
                  </div>
                </CardHeader>
                {(order?.order_status_id === 4 || order?.order_status_id === 3) && (
                  <Button
                    color="danger"
                    onClick={() => {
                      setRefundAmount(order?.total_amount || "");
                      setShowRefundModal(true);
                    }}
                  >
                    <i className="ri-refund-line me-1"></i> Process Refund {order?.is_trial_plan || order?.order_type_name === 'Trial Order' ? "(Trial)" : ""}
                  </Button>
                )}

                {showRefundModal && (
                  <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header bg-danger text-white">
                          <h5 className="modal-title">
                            Process Refund {order?.is_trial_plan || order?.order_type_name === 'Trial Order' ? "- Trial Order" : ""}
                          </h5>
                          <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowRefundModal(false)}
                            disabled={isRefunding}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className="mb-3">
                            <label className="form-label">Refund Amount</label>
                            <div className="input-group">
                              <span className="input-group-text">₹</span>
                              <input
                                type="number"
                                className="form-control"
                                value={refundAmount}
                                onChange={(e) => setRefundAmount(e.target.value)}
                                placeholder={order?.total_amount?.toString()}
                                min="0"
                                max={order?.total_amount}
                                step="0.01"
                              />
                            </div>
                            <small className="text-muted">
                              Defaults to full amount (₹{formatAmount(order?.total_amount)})
                            </small>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Refund Reason</label>
                            <textarea
                              className="form-control"
                              rows={3}
                              value={refundReason}
                              onChange={(e) => setRefundReason(e.target.value)}
                              placeholder="Enter reason for refund..."
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowRefundModal(false)}
                            disabled={isRefunding}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleRefund}
                            disabled={isRefunding || !refundReason}
                          >
                            {isRefunding ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                Processing...
                              </>
                            ) : (
                              "Confirm Refund"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <CardBody>
                  <div className="mb-3">
                    <OrderTracking orderTracking={order?.orderTracking} />
                  </div>

                  {order?.order_status_id == 8 && (
                    <Alert color="success" className="mb-0">
                      <div className="d-flex align-items-center">
                        <i className="ri-checkbox-circle-fill fs-4 me-2"></i>
                        <div>
                          <h6 className="alert-heading mb-1">Order Delivered Successfully!</h6>
                          <p className="mb-0 small">
                            This order was completed on {formatDate(order?.delivery_date)}.
                            Delivery status cannot be modified.
                          </p>
                        </div>
                      </div>
                    </Alert>
                  )}
                </CardBody>
              </Card>

              {/* Customer Info */}
              <Card className="shadow-sm border-0 mt-3">
                <CardHeader className="bg-info-subtle text-dark d-flex justify-content-between">
                  <h5 className="mb-0">👤 User Profile</h5>
                  <Link
                    to={`/user/view/${order?.user?.id}`}
                    className="btn btn-outline-light btn-sm text-dark fw-bold"
                  >
                    View Profile
                  </Link>
                </CardHeader>
                <CardBody>
                  <ul className="list-unstyled vstack gap-3">
                    <li className="d-flex align-items-center">
                      <img
                        src={order?.user?.profile}
                        alt="Customer"
                        className="avatar-sm rounded-circle me-3 border"
                      />
                      <div>
                        <h6 className="mb-0 d-flex align-items-center flex-wrap gap-1">
                          <span>{order?.user?.name}</span>
                          <i
                            className="ri-pencil-fill text-primary ms-1 cursor-pointer"
                            style={{ cursor: "pointer", fontSize: "14px" }}
                            onClick={toggleEditNameModal}
                            title="Edit Name"
                          />
                          {isNewCustomer(order?.user) && (
                            <Badge color="success" className="badge-soft-success ms-1 fs-11">
                              <i className="ri-user-star-fill me-1"></i>New
                            </Badge>
                          )}
                        </h6>
                        <small className="text-muted">{order?.user?.mobile_number}</small>
                        {order?.alternate_contact_number && (
                          <div>
                            <small className="text-primary fw-semibold">Alt Contact: {order.alternate_contact_number}</small>
                          </div>
                        )}
                      </div>
                    </li>
                    <li>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6 className="mb-0">📦 Shipping Address:</h6>
                        <Button
                          color="soft-primary"
                          size="sm"
                          className="btn-soft-primary py-0 px-2 fs-12 d-inline-flex align-items-center gap-1"
                          onClick={() =>
                            handleOpenMapModal({
                              title: `${order?.user?.name || "Customer"} Location`,
                              address: order?.shipping_address,
                              lat: order?.user?.lat,
                              lng: order?.user?.long,
                            })
                          }
                        >
                          <i className="ri-map-pin-line fs-12"></i> View Location
                        </Button>
                      </div>
                      <p className="text-muted mb-0">{order?.shipping_address}</p>
                    </li>
                  </ul>
                </CardBody>
              </Card>

              {/* Edit User Name Modal */}
              <Modal isOpen={editNameModal} toggle={toggleEditNameModal} centered>
                <ModalHeader toggle={toggleEditNameModal}>Edit User Name</ModalHeader>
                <ModalBody>
                  <FormGroup className="mb-0">
                    <Label htmlFor="userNameInput">User Name</Label>
                    <Input
                      type="text"
                      id="userNameInput"
                      value={editNameValue}
                      onChange={(e) => setEditNameValue(e.target.value)}
                      placeholder="Enter user name"
                    />
                  </FormGroup>
                </ModalBody>
                <ModalFooter>
                  <Button color="light" onClick={toggleEditNameModal} disabled={updatingName}>
                    Cancel
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#28a8df",
                      borderColor: "#28a8df",
                    }}
                    className="text-white"
                    onClick={handleSaveUserName}
                    disabled={updatingName}
                  >
                    {updatingName ? "Saving..." : "Save"}
                  </Button>
                </ModalFooter>
              </Modal>

              {/* View Location Map Modal */}
              <Modal isOpen={mapModal} toggle={toggleMapModal} size="lg" centered>
                <ModalHeader toggle={toggleMapModal}>
                  <i className="ri-map-pin-2-fill text-danger me-2"></i>
                  Location Map {mapLocationData?.title ? `- ${mapLocationData.title}` : ""}
                </ModalHeader>
                <ModalBody className="p-3">
                  {mapLocationData && (
                    <>
                      <div className="mb-3 p-2 bg-light rounded border">
                        {mapLocationData.address && (
                          <p className="mb-1 text-dark fw-semibold">
                            <i className="ri-building-line me-1 text-primary"></i>
                            {mapLocationData.address}
                          </p>
                        )}
                        {mapLocationData.lat && mapLocationData.lng ? (
                          <small className="text-muted">
                            <strong>Coordinates:</strong> {mapLocationData.lat}, {mapLocationData.lng}
                          </small>
                        ) : null}
                      </div>
                      <div className="rounded overflow-hidden border" style={{ height: "400px" }}>
                        <iframe
                          title="Location Map"
                          width="100%"
                          height="100%"
                          frameBorder="0"
                          style={{ border: 0 }}
                          src={
                            mapLocationData.lat && mapLocationData.lng
                              ? `https://maps.google.com/maps?q=${mapLocationData.lat},${mapLocationData.lng}&z=15&output=embed`
                              : `https://maps.google.com/maps?q=${encodeURIComponent(mapLocationData.address || "")}&z=15&output=embed`
                          }
                          allowFullScreen
                        ></iframe>
                      </div>
                    </>
                  )}
                </ModalBody>
                <ModalFooter>
                  {mapLocationData?.lat && mapLocationData?.lng && (
                    <a
                      href={`https://www.google.com/maps?q=${mapLocationData.lat},${mapLocationData.lng}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-secondary me-auto btn-sm"
                    >
                      <i className="ri-external-link-line me-1"></i> Open in Google Maps Tab
                    </a>
                  )}
                  <Button color="secondary" onClick={toggleMapModal}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
            </Col>
          </Row>
        </div>

        {/* Modals */}
        <OrderStatusModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          orderStatusLists={(orderStatusLists || []).map(status => ({ ...status, id: status.id.toString() }))}
          handleStatus={handleStatus}
          currentStatus={order?.orderStatus?.id || ""}
        />

        <OrderRouteUpdate
          isOpen={isRouteModalOpen}
          toggle={toggleRouteModal}
          selectedRoute={selectedRoute}
          setSelectedRoute={setSelectedRoute}
          ordersListRoute={ordersListRoute || []}
          handleRouteUpdate={handleRouteUpdate}
        />

        <OrderStoreUpdate
          isOpen={isStoreModalOpen}
          toggle={toggleStoreModal}
          selectedStore={selectedStore}
          setSelectedStore={setSelectedStore}
          ordersListStore={ordersListStore || []}
          handleStoreUpdate={handleStoreUpdate}
        />

        <OrderDeliveryDateUpdate
          isOpen={isDeliveryDateModalOpen}
          toggle={toggleDeliveryDateModal}
          selectedDeliveryDate={selectedDeliveryDate ? selectedDeliveryDate.toISOString() : ""}
          setSelectedDeliveryDate={(dateString: string) => setSelectedDeliveryDate(dateString ? new Date(dateString) : null)}
          handleDeliveryDateUpdate={handleDeliveryDateUpdate}
        />

        <DeliveryDriverAllocateOrder
          isOpen={isDriverModalOpen}
          toggle={toggleDriverModal}
          selectedDriver={selectedDriver}
          setSelectedDriver={setSelectedDriver}
          ordersListDriver={ordersListDriver || []}
          handleDriverUpdate={handleDriverUpdate}
        />
      </Container>
    </div>
  );
};

export default OrderDetail;